/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVersionBuildIdQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsSbomVersionBuildIdQueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsSbomVersionBuildIdQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVersionBuildIdQueryOperator>): AppSecopsSbomVersionBuildIdQueryOperator {
        let obj = Object.assign(new AppSecopsSbomVersionBuildIdQueryOperator(), model);
        AppSecopsSbomVersionBuildIdQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVersionBuildIdQueryOperator>): AppSecopsSbomVersionBuildIdQueryOperator {
        if (!model) return null;
        return AppSecopsSbomVersionBuildIdQueryOperator.newInstance(<AppSecopsSbomVersionBuildIdQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVersionBuildIdQueryOperator) {
        if (!obj) return;

        models.AppSecopsSbomVersionBuildIdQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVersionBuildIdQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsSbomVersionBuildIdQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Build ID(s) associated with the SBOM version to include
     */
    build_ids: Array<string>;

}
